import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewContainerRef
} from '@angular/core';
import { map } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { OnClickActions, loadScript } from "@paypal/paypal-js";
import { UserPaypalPaymentsApiService } from 'src/app/api/services';
import { PaymentInfo, PaymentIds, PaymentObject, PayPalAction, PaypalActionObj, PaymentMethodEnum } from 'src/shared/models/payment.model';
import { CustomSpinnerService } from 'src/shared/services/helpers/custom-spinner.service';
import { MyLogger } from 'src/shared/services/helpers/logging.service';
import { PaymentsHelperService } from 'src/shared/services/helpers/payments-helper.service';
import { MspApiService } from 'src/shared/services/msp-api.service';
import { PaypalHelperService } from 'src/shared/services/helpers/paypal-helper.service';
import { TranslateService } from '@ngx-translate/core';
import { BookingHelperService } from 'src/shared/services/helpers/booking-helper.service';

export var paypal: any;

@Component({
	selector: 'vl-pay-with-paypal',
	templateUrl: './pay-with-paypal.component.html',
	styleUrls: ['./pay-with-paypal.component.scss'],
})
export class PayWithPayPalComponent extends MyLogger implements OnInit, AfterViewInit, OnDestroy {
	@Input() paymentInfo: PaymentInfo;

	@Output() back: EventEmitter<any> = new EventEmitter<any>();
	@Output() onError: EventEmitter<any> = new EventEmitter<any>();
	@Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();


	private orderId;
	type: 'EUR' | ' USD' | any;
	btnId = 'paypal-btn-id';
	paymentIds: PaymentIds = {
		main: null,
		freeHours: null
	}

	constructor(private UserPaypalPaymentsApiService: UserPaypalPaymentsApiService,
				private activatedRoute: ActivatedRoute,
				private spinner: CustomSpinnerService,
				public viewContainerRef: ViewContainerRef,
				private cd: ChangeDetectorRef,
				private translate: TranslateService,
				private bookingHelper: BookingHelperService,
				private paypalHelperService: PaypalHelperService,
				private paymentHelper: PaymentsHelperService,
				private mspApiService: MspApiService) {
		super('PayPal Payment')
		this.spinner.show();
		this.activatedRoute.queryParams.subscribe(r => {
			if (r.code) {
				console.log(r.code);
			}
		})
	}

	ngOnInit(): void {
		this.type = this.paymentInfo.currency;
	}

	public async ngAfterViewInit(): Promise<void> {
		const clientId = await this.UserPaypalPaymentsApiService.getPayPalClientId().toPromise();
		loadScript({
			clientId: clientId.value,
			currency: this.paymentInfo.currency,
			disableFunding: 'credit,card',
			commit: true
		})
			.then((paypal) => {
				paypal.Buttons(
					{
						style: {
							label: 'paypal',
							layout: 'vertical',
							tagline: false
						},
						onClick: async (data: any, actions: OnClickActions) => {
							try {
								await this.checkReadyToAction();
								return actions.resolve(); // Resolve actions if ready
							  } catch (error) {
								return actions.reject(); // Reject actions if not ready
							}
						},
						createOrder: () => {
							return this.getPaymentOrder();
							// return this.paymentInfo.type === 'subscription'
							// 	? this.createOrderForSubscription() : this.createOrderForBooking();
						},
						onInit: () => {
							this.spinner.hide();
						},
						onApprove: (data, actions) => {
							this.log('onApprove - transaction was approved, but not authorized', data, actions);

							this.log('onApprove - you can get full order details inside onApprove: ', data);
							// const fullName = `${ data.payer.name.given_name } ${ details.payer.name.surname }`
							return new Promise((success) => {
								this.paypalHelperService.updateProfileAfterPayment('', async () => {
									await this.spinner.show(false, this.translate.instant('payment.wait-payment'));
									success();
									this.captureOrder();
								});
							})
						},
					}
				).render('#' + this.btnId);
			})
			.catch((err) => {
				this.error("failed to load the PayPal JS SDK script", err);
			});
	}

	async checkReadyToAction(): Promise<void> {
		return new Promise<void>((resolve, reject) => {
		  this.bookingHelper.towerReadyToAction(this.paymentInfo.type, (valid) => {
			if (!valid) {
			  reject('Action is not ready');
			} else {
			  resolve();
			}
		  }, this.paymentInfo.bookingId, this.paymentInfo.groupId, this.paymentInfo.subscriptionStartDate);
		});
	}

	public ngOnDestroy(): void {
		this.viewContainerRef.detach();
		this.log('destroy')
	}


	private createOrderForBooking() {
		return this.UserPaypalPaymentsApiService.createOrder1({
			body: {
				bookingId: this.paymentInfo.bookingId,
				freeHours: this.paymentInfo.freeHoursUsed
			}
		}).pipe(
			map(res => {
				Object.keys(res.paymentsToMethod).forEach((k: any) => {
					console.log(k, res.paymentsToMethod[k]);
					if (res.paymentsToMethod[k] === 'FREE_HOURS') {
						this.paymentIds.freeHours = Number(k);
					} else {
						this.paymentIds.main = Number(k);
					}
				});
				this.orderId = res.paymentIntent.orderId;
				return res.paymentIntent.orderId
			})).toPromise();
	}

	private createOrderForSubscription() {
		return this.UserPaypalPaymentsApiService.createSubscriptionPaymentIntent2({
			body: {
				towerGroupId: this.paymentInfo.groupId,
				onDateTime: new Date(this.paymentInfo.subscriptionStartDate).toISOString()
			}
		}).pipe(
			map(res => {
				Object.keys(res.paymentsToMethod).forEach((k: any) => {
					console.log(k, res.paymentsToMethod[k]);
					if (res.paymentsToMethod[k] === 'FREE_HOURS') {
						this.paymentIds.freeHours = Number(k);
					} else {
						this.paymentIds.main = Number(k);
					}
				});
				this.orderId = res.paymentIntent.orderId;
				return res.paymentIntent.orderId
			})).toPromise();
	}

	private captureOrder() {
		let body = {
			paymentId: this.paymentIds.main,
		};

		if (this.paymentIds.freeHours) {
			body = {
				...body,
				...{ freeHoursPaymentId: this.paymentIds.freeHours }
			}
		}
		this.UserPaypalPaymentsApiService.captureOrder1({
			body: body
		}).subscribe(r => {
			const forAnalytics = { ...this.paymentInfo };
			forAnalytics.method = PaymentMethodEnum.PAYPAL;
			// this.analyticsService.logEvent(AnalyticsEvents.CompletePayment, forAnalytics);
			switch (this.paymentInfo.type) {
				case PaymentObject.PayPerUse:
					this.terminateBooking();
					break;
				case PaymentObject.Subscription:
					this.createSubscription(this.paymentIds.main, this.paymentInfo.subscriptionStartDate);
					break;
				case PaymentObject.Purchase:
					this.finishPurchase();
					break;
			}
		}, async error => {
			this.handlePaypalAction({ action: PayPalAction.Error });
			await this.spinner.hide();
		});
	}

	private handlePaypalAction(ppAction: PaypalActionObj) {
		console.log('handlePaypalAction', ppAction);
		switch (ppAction.action) {
			case PayPalAction.Report:
				this.terminateBooking()
				break;
			case PayPalAction.Cancel:
				break;
			case PayPalAction.Error:
				this.onError.emit();
				break;
			case PayPalAction.Subscription:
				this.createSubscription(ppAction.props.paymentIds.main, this.paymentInfo.subscriptionStartDate);
				break;
		}
	}

	terminateBooking() {
		this.paymentHelper.terminateBooking(
			Number(this.paymentInfo.bookingId),
			this.paymentInfo.booking).subscribe(async () => {
			// this.paymentActive = false;
			this.onSuccess.emit();
			this.cd.detectChanges();
			await this.spinner.hide();
		});
	}

	createSubscription(paymentId, startDate) {
		this.paymentHelper.createSubscription(
			paymentId,
			this.paymentInfo.groupId,
			startDate
		).subscribe(async () => {
			// this.paymentActive = false;
			this.onSuccess.emit();
			this.cd.detectChanges();
			await this.spinner.hide();
		});
	}

	getPaymentOrder() {
		switch (this.paymentInfo.type) {
			case PaymentObject.PayPerUse:
				return this.createOrderForBooking();
			case PaymentObject.Purchase:
				return this.mspApiService.createPurchasePaymentIntent(this.paymentInfo?.purchase?.id, PaymentMethodEnum.PAYPAL)
					.pipe(
						map(res => {
							Object.keys(res.paymentsToMethod).forEach((k: any) => {
								console.log(k, res.paymentsToMethod[k]);
								if (res.paymentsToMethod[k] === 'FREE_HOURS') {
									this.paymentIds.freeHours = Number(k);
								} else {
									this.paymentIds.main = Number(k);
								}
							});
							this.orderId = res.paymentIntent.orderId;
							return res.paymentIntent.orderId
						})).toPromise();
			case PaymentObject.Subscription:
				return this.createOrderForSubscription();
		}
	}

	finishPurchase() {
		this.mspApiService.pingPayment(this.paymentInfo.purchase.id).subscribe(async () => {
			// await this.storageService.setItem(StorageEnums.PurchaseRedirectUrl, null);
			this.onSuccess.emit();
			this.cd.detectChanges();
			await this.spinner.hide();
		}, async error => {
			this.onSuccess.emit();
			this.cd.detectChanges();
			await this.spinner.hide();
		});
	}
}
